import { dateConvert } from "../../../src/utils";
import { CLEAR_ADMIN_ACTIVITY_LOGS, GET_ACTIVITY_LOG, GET_FILTERS_ACTIVITY_LOG } from "../../actions/action-types";
import { updateCurrUser } from "../../actions/auth";
import { setOrganisationFeatures, updateOrganization } from "../../actions/company";
import { setAllUserDetails } from "../../actions/userDetails";
import { label, notifyIcon, number, quote, requestMethod } from "../../config";
import config from "../../env.config";
import { downloadBlobAsFile } from "../../helper/downloadBlobAsFile";
import { verifyCompanyEmailPayload } from "../../helper/sendMailPayload";
import { fetch, logoutUser } from "../../shared/services/api.service";
import store from "../../store/index";
import { getNotification } from "../../utils/common";
import { checkAdmin, checkApiSuccess, splitString } from "../../utils/index";

/**
 * Get User List for Admin console
 * @param {string} data
 * @returns Email
 * @author Himanshi Chawla
 */

export const getUsersForAdmin = (bodyData) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.POST,
        url: `${config.BASE_URL.BASE_API_URL}/admin/getUsersForAdmin`,
        data: bodyData,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getActiveInActiveRoles = () => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/admin/getActiveInActiveRoles`,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/**
 * Deactivate user
 * @param {string} data
 * @returns Email
 * @author Himanshi Chawla
 */

export const changeAccountStatus = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/changeAccountStatus`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data?.pendingTasks;
  }
};

/**
 * Deactivate user
 * @param {string} data
 * @author Sejal
 */

export const deactivateUserFromCompany = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deactivateUserFromCompany`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response.data.data?.pendingTasks;
  }
};

/**
 * Sends invitation mail to multiple users
 * @param {Array} emails
 * @param {*String} sender
 * @returns
 */
const sendMultipleInvitationMail = async (emails, sender) => {
  const requestPayload = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/admin/sendMultipleInvitationMail`,
      data: {emails: emails, type: "Invite"},
    },
    response = await fetch(requestPayload, false, emails.length ? true : false);
  return response;
};

/**
 * Activates users through email
 * @param {Array} emails
 * @returns
 * @author Sarthak Arora
 */
const activateUsersthroughEmail = async (emails) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/activateUsersthroughEmail`,
    data: {emails: emails},
  },
  response = await fetch(requestPayload, false, false);
  return response;
};
/**
 * Removes the existing emails from input emails
 * @param {String} duplicateEmails
 * @param {Array} inputEmails
 */
export const removeDuplicateEmails = (duplicateEmails, inputEmails) => {
  let duplicateEmailsArray = splitString(duplicateEmails, ",");
  return inputEmails.filter(function (val) {
    return duplicateEmailsArray.indexOf(val) == number.MINUS_ONE;
  });
};

/**
 * Invites Users
 * @param {Array} emails
 * @param {String} sender
 */
export const inviteUsers = async (emails, sender, type, Id) => {
  if (type === "default") {
    const successfulRes = await checkEmails(emails.toString());
    if (successfulRes && successfulRes.duplicateEmails) {
      emails = removeDuplicateEmails(successfulRes.duplicateEmails, emails);
    }
    if (emails.length > number.ZERO && successfulRes) {
      let response = await addUsers(emails, sender, type);
      if (response && checkAdmin(sender.isAdmin)) {
        handleMails(emails, sender);
      }
      return emails;
    } else return successfulRes;
  }
  if (type === "advanced") {
    const successfulRes = await checkEmails(emails.toString());
    if (successfulRes && successfulRes.duplicateEmails) {
      emails = removeDuplicateEmails(successfulRes.duplicateEmails, emails);
    }
    if (checkAdmin(sender.isAdmin)) {
      handleAdvancedMails(emails);
    }
    return emails;
  }
  if (type == "project") {
    return handleUsersFromProject(emails, sender, type);
  } else {
    if (checkAdmin(sender.isAdmin)) {
      if (type == "resend") addActivityLogForResetResendAdmin({ admin: sender.id, user: Id, type: type }, false);
      handleMails(emails, sender);
    }
  }
};

/**
 * handles the addition of new users directly from project
 * @param {String} emails
 * @param {Object} sender
 * @returns required UserId
 */

const handleUsersFromProject = async (emails, sender, type) => {
  const state = store.getState();
  const successfulRes = await checkEmails(emails);
  if (successfulRes && !successfulRes?.duplicateEmails) {
    let response = await addUsers(emails, sender, type);
    if (response) {
      return response;
    }
  } else {
    let userId = successfulRes["userId"];
    let userCompanyId = successfulRes["companyId"];
    if (state.auth.user.companyId == userCompanyId) {
      let exisitingUser = state.team?.projectMembers?.find((member) => member.UserId == userId)?.UserId;
      if (!exisitingUser) {
        return successfulRes;
      } else {
        getNotification(label.USER_IN_PROJECT, notifyIcon.WARNING_ICON);
      }
    } else {
      getNotification(label.EXIST_IN_DRUTAS, notifyIcon.WARNING_ICON);
    }
  }
};

/**
 *
 * @param {Array} emails
 * @param {Object} sender
 * @returns {Object} response from sendMultipleInvitationMail
 */
export const handleMails = async (emails, sender) => {
  let response = await sendMultipleInvitationMail(emails, sender);
  let expirationTime = response?.data?.data.expirationTime;
  if (response?.data.success) {
    updateInviteExpirationTime(expirationTime, emails);
  }
  return response;
};

/**
 * Activates users through email
 * @param {Array} emails
 * @returns
 * @author Sarthak Arora
 */
export const handleAdvancedMails = async (emails) => {
  let response = await activateUsersthroughEmail(emails);
  return response;
};

export const updateInviteExpirationTime = async (expirationTime, emails) => {
  const state = store.getState();
  const requestConfig = {
    method: requestMethod.PATCH,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateInviteExpirationTime`,
    data: {
      expirationTime: expirationTime,
      emails: emails,
      companyId: state.auth.user.companyId,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Updates user role and info
 * @param {Object} bodyData
 * @returns
 */
export const updateUserAndRole = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateUserAndRole`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Updates user role and info for active users
 * @param {Object} bodyData
 * @returns
 */
export const updateUserAndRoleAct = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateUserAndRoleActiveUser`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Enables/disables organization feature
 * @param {Object} bodyData
 * @returns
 */
export const updateFeatureSetting = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateFeatureSetting`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get company functional area
 * @param {*} type
 * @param {*} companyId
 * @returns
 * @author Ankit Negi
 */
export const getCompanyFunctionalArea = async (type, companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getCompanyFunctionalArea`,
    params: { type, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Add compnay functional area
 * @param {Object} payload
 * @author Ankit Negi
 */
export const addCompanyFunctionalArea = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addCompanyFunctionalArea`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  } else return null;
};

/**
 * Update compnay functional area
 * @param {Object} bodyData
 * @returns
 * @author Ankit Negi
 */
export const updateCompanyFunctionalArea = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateCompanyFunctionalArea`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 *  Delete company functional area
 * @returns
 * @author Ankit Negi
 */
export const deleteCompanyFunctionalArea = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteCompanyFunctionalArea`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  } else return null;
};

/**
 *  Sort/Reorder company functional area
 * @returns
 * @author Ankit Negi
 */
export const sortCompanyFunctionalArea = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/sortCompanyFunctionalAreas`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  } else return null;
};

export const getAdminUser = async (userId, companyId, searchText = "", accountStatus) => {
  const params = { adminConUser: userId, companyId, searchText };
  if (accountStatus !== undefined && accountStatus !== null && accountStatus !== "") {
    params.accountStatus = accountStatus;
  }
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUserProfileDetailsForAdmin`,
    params,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getUserOrgDetails = async (userId, companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUserProfileConstants`,
    params: { adminConUser: userId, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const checkExistingTaskCodeAndEmail = async (taskCode, email) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/checkUniqueTaskCodeEmail`,
    params: { taskCode, email },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data?.data?.result;
  } else return null;
};

/**
 * Used to render tags for the common page for tags in admin console
 * @returns
 */
export const getCompanyTags = async (companyId, isAdminPage) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getCompanyTags`,
    params: { companyId, isAdminPage },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};
/**
 * Used to get  Default Values For ManageUsers
 * @returns
 */
export const getDefaultValuesForManageUsers = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getDefaultValuesForManageUsers`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Used to update company tags
 * @returns
 */
export const updateCompanyTags = async (payload) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateCompanyTags`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * API call to merge two tags
 * @returns {void}
 * @Author Sejal
 * @param  {Object} payload
 */
export const mergeTags = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/mergeTags`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Used to delete company tags from the commmon page for tags
 * @returns
 */
export const deleteCompanyTags = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteCompanyTags`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Used to get taskAttachments
 */
export const getTaskAttachments = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getAttachmentDetailsForAdmin`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Used to get taskAttachments meta data
 */
export const getSpaceUtilMetaData = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getSpaceUtilMetaData`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Used to add company tags from the commmon page for tags
 * @returns
 */
export const addCompanyTags = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addCompanyTags`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateUserLoginType = async ({ userId, googleSSO, activate, adminId, loginEmailData, mobileNo, isSMSOtp }) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/common/updateUserLoginType`,
    data: { adminConUser: userId, googleSSO, activate, adminId, mobileNo, isSMSOtp },
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    if (loginEmailData) sendLoginTypeChangeMail({ googleSSO, activate, loginEmailData });
    return response.data?.data;
  } else return null;
};

const sendLoginTypeChangeMail = async ({ googleSSO, activate, loginEmailData }) => {
  const state = store.getState();
  const companyId = state.auth.user?.companyId;

  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/sendLoginTypeChangeMail`,
    data: {
      googleSSO,
      activate,
      companyId,
      ...loginEmailData,
    },
  };

  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) return response;
  else return null;
};

/**
 * Updates user role and info
 * @param {Object} emails
 * @returns
 */
export const checkEmails = async (emails) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/user/checkEmails`,
    data: {
      emails: emails,
    },
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response) && response.data.data["duplicateEmails"].length > number.ZERO) {
    getNotification(response.data.message, notifyIcon.WARNING_ICON);
    return response.data.data;
  } else if (checkApiSuccess(response) && response.data.data["duplicateEmails"].length === number.ZERO) {
    return true;
  } else return false;
};

export const addUsers = async (emails, sender, type) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/user/registerUsers`,
    data: {
      emails: emails,
      companyId: sender.companyId,
      password: label.DEFAULT_PASSWORD,
      createdBy: sender.id,
      accountStatus: type == "project" ? number.TWO : number.THREE,
      invitedFrom: type,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return false;
};

/**
 * Get Organization Data.
 * @param {string} data
 * @returns Name, DisplayName, Email
 * @author Shivam Mishra
 */

export const getOrganization = async (companyId) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getOrganization`,
    params: { companyId },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Get follower Mail Time
 * @param {int} companyId
 * @returns followerMailTimeOptions
 * @author Pragun Gandotra
 */
export const getFollowerMailTimeOptions = async () => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getFollowerMailTimeOptions`,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Get follower Mail Time
 * @param {int} companyId
 * @returns followerMailTime
 * @author Pragun Gandotra
 */

export const getFollowerMailTime = async (companyId) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getFollowerMailTime`,
    params: { companyId },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Update follower Mail Time
 * @param {Object} payload - Payload containing companyId and optional fields (followerUpdateTime, managerVariableId, followerUpdateInterval)
 * @returns {Boolean}
 * @author Pragun Gandotra
 */
export const updateFollowerMailTime = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateFollowerMailTime`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * handling api for update organization
 * @param {payload of the formData, orgData}
 * @returns {void}
 * @author agupta
 */

export const updateOrg = async (formData, orgData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/common/updateOrganization`,
    data: formData,
  };
  const response = await fetch(requestConfig, true, true);
  const payload = { operationalTeamName: orgData.operationalTeam, companyPicture: orgData.orgPicture, displayName: orgData.organization };
  if (checkApiSuccess(response)) {
    store.dispatch(updateOrganization(orgData));
    store.dispatch(updateCurrUser(payload));
    return true;
  }
};

/**
 * handling api for delete organization
 * @param {payload}
 * @returns {void}
 * @author agupta
 */
export const deleteOrg = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/admin/deleteOrganization`,
      data: payload,
    };
    const response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      dispatch(logoutUser());
    }
  };
};

/**
 * Get all filter data for activity logs.
 * @returns {void}
 * @author Prachi Jain
 */

export const getFiterData = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/admin/getFiterData`,
      params: {
        company: payload.company,
      },
    };
    const response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(storeFilterData(response.data.data));
    }
  };
};

/**
 * handling api for getting all activity logs
 * @returns {void}
 * @author Prachi Jain
 */

export const getActivityLog = (payload) => {
  const startDate = dateConvert(payload.startDate);
  const endDate = dateConvert(payload.endDate);
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/admin/getActivityLog`,
      params: {
        orgId: payload.company,
        offset: payload.offset,
        pageSize: payload.pageSize,
        startDate: startDate,
        endDate: endDate,
        ...(payload.search !== undefined ? { search: payload.search } : {}),
        ...(payload.users ? { users: payload.users } : {}),
        ...(payload.actions ? { actions: payload.actions } : {}),
      },
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      dispatch(storeActivityLog(response.data.data));
      return response.data.data;
    }
  };
};

/**
 * Adds activity log for reset password and resend invite
 */
export const addActivityLogForResetResendAdmin = async (payload, isShowNotifications) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/resetResendActivityLogAdmin`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, isShowNotifications);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * handling api to check is CompanyName Exist
 * @param {payload}
 * @returns {void}
 */
export const isCompanyNameExist = async (companyName) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/isCompanyNameExist`,
    params: { companyName: companyName },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * handling api to verify CompanyEmail Api
 * @param {payload}
 * @returns {void}
 */
export const verifyCompanyEmailApi = (payload) => {
  return async (dispatch) => {
    const requestPayload = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/app/verifyCompanyEmailByToken`,
      data: payload,
    };
    const response = await fetch(requestPayload, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/**
 * handling api to send Verification Mail
 * @param {payload}
 * @returns {void}
 */
export const sendVerificationMail = async (companyData, encryptedId, encryptedMail) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/sendActivationMail`,
    data: verifyCompanyEmailPayload(companyData, encryptedId, encryptedMail),
  };
  const response = await fetch(requestPayload, false, true);
  return response;
};

export const sendCompanyEmailVerification = async (payload) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/sendCompanyEmailVerification`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, true);
  return response;
};

/**
 * API cal to check whether is Company Email Verified
 * @param {companyEmail, companyAdminName, companyId}
 * @returns {void}
 */
export const isCompanyEmailVerified = async (Id) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/isCompanyEmailVerified`,
    params: { companyId: Id },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getUsageSummary = async (payload) => {
  const { companyId, summaryFilter, startDate, endDate, limit, offset } = payload ?? {};

  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUsageSummary`,
    params: { companyId, summaryFilter, startDate, endDate, limit, offset },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getUsageSummaryChart = async (payload) => {
  const { companyId, summaryFilter, startDate, endDate } = payload ?? {};

  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUsageSummaryChart`,
    params: { companyId, summaryFilter, startDate, endDate },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * saving the filters data for activity logs in redux store
 * @param {*} activity
 * @returns {type Of Action}
 * @returns {list of queues to set}
 */

export const storeFilterData = (data) => {
  return {
    type: GET_FILTERS_ACTIVITY_LOG,
    payload: data,
  };
};

/**
 * saving the activity logs in redux store
 * @param {*} activity
 * @returns {type Of Action}
 * @returns {list of queues to set}
 */

export const storeActivityLog = (data) => {
  return {
    type: GET_ACTIVITY_LOG,
    payload: data,
  };
};

export const clearAdminActivityLogs = () => {
  return {
    type: CLEAR_ADMIN_ACTIVITY_LOGS,
  };
};

export const addReplacementTask = async (payload) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addReplacementTask`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    getNotification(`${response.data.data?.ProjectTaskId} ${quote.TASK_ASSIGNMENT_NOTIFICATION}`, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

export const getFeatureStatus = async (companyId) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getFeatureStatus`,
    params: { companyId },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    store.dispatch(setOrganisationFeatures(response.data.data));
    return response.data.data;
  }
};

/**
 * Add chatbot attachment
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const addChatbotAttachments = async ({ payload, userId, companyId }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addChatbotAttachments`,
    params: { userId, companyId },
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chatbot attachments
 * param {*} userId
 * @returns
 * @author Ankit Negi
 */
export const getChatbotAttachments = async (userId, companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getChatbotAttachments`,
    params: { createdBy: userId, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Delete chatbot attachment
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const deleteChatbotAttachment = async (attachmentId) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteChatbotAttachment`,
    data: {
      attachmentId,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Add chatbot prompt
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const addChatbotPrompt = async ({ text, createdBy, companyId }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addChatbotPrompt`,
    data: { text, createdBy, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chatbot prompt
 * param {*} createdBy
 * @returns
 * @author Ankit Negi
 */
export const getChatbotPrompt = async (createdBy, companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getChatbotPrompt`,
    params: { createdBy, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Update chatbot prompt
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const updateChatbotPrompt = async ({ text, createdBy, promptId }) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateChatbotPrompt`,
    data: {
      text,
      createdBy,
      promptId,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chatbot attachmenr isSynced value
 * param {*} companyId
 * @returns
 * @author Muskan Thakur
 */
export const getChatbotAttachmentsSync = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getChatbotAttachmentsSync`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Update chatbot attachment isSynced value
 * @param {*} payload
 * @returns
 * @author Muskan Thakur
 */
export const updateChatbotAttachmentsSync = async ({ syncId, userSynced, isSynced }) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateChatbotAttachmentsSync`,
    data: {
      userSynced,
      syncId,
      isSynced,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Add chatbot attachment isSynced value
 * @param {*} payload
 * @returns
 * @author Muskan Thakur
 */
export const addChatbotAttachmentsSync = async ({ isSynced, companyId, userSynced }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addChatbotAttachmentsSync`,
    data: { isSynced, companyId, userSynced },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Syncs all the attachments
 * @param {*} payload
 * @returns
 * @author Muskan Thakur
 */
export const syncAttachments = async ({ isSuperAdmin, tenantId }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.CHATBOT_BACKEND_URL}/api/v1/bot/process-s3-documents`,
    data: { isSuperAdmin, tenantId },
  };
  const response = await fetch(requestConfig, false, false);
  if (!response?.data?.message) {
    getNotification(quote.ATTACHMENT_SYNC_FAIL, notifyIcon.ERROR_ICON);
  }
  return response?.data?.message;
};

export const addUpdateAdminUserFilter = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addUpdateAdminUserFilter`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getAdminUserFilters = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getAdminUserFilters`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getProfileControlSettings = async (payload) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getProfileControlSettings`,
    params: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const updateProfileControlSettings = async (params) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateProfileControlSettings`,
    data: params,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addAdminCustomVariables = async (payload) => {
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addAdminCustomVariables`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const deleteAdminCustomVariables = async (id) => {
  const requestPayload = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteAdminCustomVariables`,
    data: { id },
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

export const updateAdminCustomVariables = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateAdminCustomVariables`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

const adminCustomVariablesTemplateFileName = (fieldName, prefill) => {
  const chipName =
    String(fieldName ?? label.CHIP)
      .trim()
      .toLowerCase()
      .replace(/[^\w.-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "") || "chip";
  return prefill ? `${chipName}-prefill.xlsx` : `${chipName}.xlsx`;
};

/**
 * Downloads admin custom variable chip list template (xlsx).
 * @param {{ companyId: string|number, id: string, prefill: boolean, fieldName?: string }} params
 */
export const downloadAdminCustomVariablesTemplate = async ({ companyId, id, prefill, fieldName }) => {
  const requestPayload = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/template/download/adminCustomVariables`,
    params: {
      prefill,
      companyId,
      id,
      fileType: "xlsx",
    },
    responseType: "blob",
  };
  const response = await fetch(requestPayload, true, false);
  if ( response?.data) {
    downloadBlobAsFile(response.data, adminCustomVariablesTemplateFileName(fieldName, prefill));
    return true;
  }
  getNotification(quote.TEMPLATE_DOWNLOAD_FAIL, notifyIcon.ERROR_ICON);
  return false;
};

/**
 * True when API body reports success (`success`, or `status: "success"`).
 * Template upload may return `{ status: "success", data: { adminVariable } }` without `success: true`.
 */
const isTemplateApiSuccess = (response) => {
  if (!response?.data) return false;
  if (checkApiSuccess(response)) return true;
  const d = response.data;
  return d.success === true || d.status === label.SUCCESS_ICON;
};

/**
 * Uploads chip list xlsx for an admin custom variable (multipart).
 * Resolves to the **admin variable** document (shape with `attributes.options`) for UI updates.
 * @param {{ companyId: string|number, id: string, file: File }} params
 */
export const uploadAdminCustomVariablesChips = async ({ companyId, id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("companyId", String(companyId));
  formData.append("id", id);
  const requestPayload = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/template/upload/adminCustomVariables`,
    data: formData,
  };
  const response = await fetch(requestPayload, true, true);
  if (!isTemplateApiSuccess(response) || !response?.data?.data) {
    getNotification(quote.TEMPLATE_UPLOAD_FAIL, notifyIcon.ERROR_ICON);
  }
  const payload = response.data.data;
  return payload.adminVariable ?? payload;
};

/**
 * Creates an integration key for API access
 * @author Muskan Thakur
 */
export const createIntegrationKey = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/createIntegrationKey `,
    data: payload,
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    getNotification(quote.API_KEY_CREATED, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  } else return null;
};

/**
 * Gets integration keys for a company
 * @author Muskan Thakur
 */
export const getIntegrationKey = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getIntegrationKey`,
    params: {
      companyId: data.companyId,
      page: data.page || 1,
      search: data.search || "",
      sortBy: data.sortBy || "createdAt",
      sortOrder: data.sortOrder ?? -1,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Gets integration services for api integration
 * @author Muskan Thakur
 */
export const getIntegrationServices = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getIntegrationServices`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Updates an existing integration key
 * @author Muskan Thakur
 */
export const updateIntegrationKey = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateIntegrationKey`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Deletes an existing integration key
 * @author Muskan Thakur
 */
export const deleteIntegrationKey = async (payload) => {
  const requestPayload = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteIntegrationKey`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    getNotification(quote.API_DELETED, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Gets integration keys details for a company
 * @author Muskan Thakur
 */
export const getIntegrationKeyById = async (integrationId, companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getIntegrationKeyById`,
    params: { integrationId, companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Add users group
 * @author Muskan Thakur
 */
export const addUsersGroup = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/common/addUsersGroup`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    const { GroupId = null } = response.data.data;

    if (GroupId) {
      getNotification(quote.GROUP_CREATED, notifyIcon.SUCCESS_ICON);
    } else {
      getNotification(quote.EXISTS_IN_GROUPS, notifyIcon.WARNING_ICON);
    }

    return GroupId;
  }
  getNotification(quote.ACTION_FAILED, notifyIcon.ERROR_ICON);
  return null;
};

/**
 * Updates an existing users group
 * @author Muskan Thakur
 */
export const updateUsersGroup = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/common/updateUsersGroup`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, false);
  if (checkApiSuccess(response)) {
    if (response.data.message === label.ALREADY_EXISTS) {
      getNotification(quote.EXISTS_IN_GROUPS, notifyIcon.WARNING_ICON);
      return null;
    } else getNotification(quote.GROUP_UPDATED, notifyIcon.SUCCESS_ICON);
    return response.data.message;
  }
  getNotification(quote.ACTION_FAILED, notifyIcon.ERROR_ICON);
  return null;
};

/**
 * Gets users group details
 * @author Muskan Thakur
 */
export const getUsersGroupDetails = async (groupId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUsersGroupDetails`,
    params: { groupId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Gets company users groups
 * @author Muskan Thakur
 */
export const getCompanyUsersGroups = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getCompanyUsersGroups`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Deletes a users group
 * @author Muskan Thakur
 */
export const deleteUsersGroup = async (groupId) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/common/deleteUsersGroup`,
    data: { groupId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(quote.GROUP_DELETED, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
  getNotification(quote.ACTION_FAILED, notifyIcon.ERROR_ICON);
  return null;
};

export const getUserDetailsAndProjects = (userId) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getUserDetailsAndProjects`,
      params: { uid: userId },
    };
    const response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      await dispatch(
        setAllUserDetails({
          details: response.data.data.userDetails || {},
          userProjects: response.data.data.projects || [],
          visitingByAdmin: true,
        })
      );
      return response.data.data;
    } else return null;
  };
};

export const addAdminVariableUserProfileValue = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/user/addAdminVariableUserProfileValue `,
    data: { values: payload },
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getAdminVariableUserProfileValue = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getAdminVariableUserProfileValue`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateVariableSorting = async (payload) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateVariableSorting`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getAdminVariableItemsByCompany = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getAdminVariableItemsByCompany`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getCommonAdminVariableItemsByCompany = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getAdminVariableItemsByCompany`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const addAdminVariableItems = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addAdminVariableItems`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const updateAdminVariableItems = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateAdminVariableItems`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const deleteAdminVariableItems = async (id) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteAdminVariableItems`,
    data: { id },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification("Variable deleted", notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
  getNotification("Failed to delete variable", notifyIcon.ERROR_ICON);
  return null;
};

export const getUsersForDynamicGroup = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getUsersForDynamicGroup`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/** Members for dynamic groups that use manager variable rules (fixed-group resolver) */
export const getUsersForFixedGroup = async (payload) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/dynamicGroup/getUsersForFixedGroup`,
    params: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
  return null;
};

export const getUserInfo = async (userId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUserInfo`,
    params: { drutasUserId: userId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getActiveMemberVariables = async () => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/common/getActiveMemberVariables`,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getAdminFilterUtilities = async () => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getAdminFilterUtilities`,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};



export const addAdminCustomVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addAdminCustomVariableDimension`,
    data,
  };
const response = await fetch(requestConfig, true, true);
if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }

};

export const addAdminCustomVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/addAdminCustomVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};


/**
 * @param {{ variableId: string|number, companyId: string|number }} params
 * @returns {Promise<{ dimensions: object[], options: object[] }|null>}
 */
export const getAdminCustomVariableDimensionAndOptions = async (params) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getAdminCustomVariableDimensionAndOptions`,
    params,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    const d = response.data?.data;
    return {
      dimensions: Array.isArray(d?.dimensions) ? d.dimensions : [],
      options: Array.isArray(d?.options) ? d.options : [],
    };
  }
  return null;
};


export const deleteAllAdminCustomVariableOptions = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteAllAdminCustomVariableOptions`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};


/**
 * Deletes a multi-dimension column.
 * @param {Object} data
 * @param {string} data.workflowVariableId
 * @param {number|string} data.workflowId
 * @param {number|string} data.id - Dimension id
 */
export const deleteAdminCustomVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteAdminCustomVariableDimension`,
    data,
  };
const response = await fetch(requestConfig, true, true);
if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }
};


export const deleteAdminCustomVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/admin/deleteAdminCustomVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};


/**
 * Updates an existing multi-dimension column.
 * @param {Object} data
 * @param {string} data.workflowVariableId
 * @param {number|string} data.workflowId
 * @param {{ id: number|string, label: string, type: string }} data.dimension
 */
export const updateAdminCustomVariableDimension = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateAdminCustomVariableDimension`,
    data,
  };
 const response = await fetch(requestConfig, true, true);
 if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  else  {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
    return null;
  }
};


export const updateAdminCustomVariableOption = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/admin/updateAdminCustomVariableOption`,
    data,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response) && response.data?.data != null) {
    return response.data.data;
  }
  if (response?.data?.message) {
    getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
  return null;
};
/**
 * Get User List for Admin console
 * @param {string} data
 * @returns Email
 * @author Bhavana
 */

export const getUsersForAdminExport = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getUsersForAdminExport`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};
